import {Button, Card, Form, Icon, Input, Select, Spin, Tooltip, Upload} from 'antd';
import React from 'react';
import {getFormFieldByType, sanitizeFieldName} from '../../util/methods';
import {LoadingOutlined, PlusOutlined} from '@ant-design/icons';

class Create extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadFile: true,
      count: 1,
      fileList: [],
      file: null,
      loading: false,
    }
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
    // this.props.getApplicationModules();
  }

  handleSubmit = (e) => {
    const {match, form} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      // console.log(values);
      if (err) {
        const {data} = this.props;
        if (data && data.logo) {
          if (Object.keys(err).length === 1 && Object.keys(err)[0] === 'files') {

          } else {
            return console.log(err);
          }
        } else {
          return console.log(err);
        }
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, authUser, form} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${resource}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical" autoComplete="off">
            {
              Object.keys(filters).map((item) => {
                  return getFormFieldByType(filters, item, getFieldDecorator, data);
              })
            }
            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>

        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'organisation_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
